import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ReportButton from "@/components/feature/LovemoReportButton";
import LovemoSeoManager from "@/components/feature/LovemoSeoManager";
import LovemoSchemaManager from "@/components/feature/LovemoSchemaManager";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <LovemoSeoManager />
        <LovemoSchemaManager />
        <AppRoutes />
        <ReportButton />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
